module.exports = __webpack_public_path__ + "static/media/our-values-awards-3.789ccb42.png";